import { AfterViewInit, Component, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
})
export class CommonModalComponent implements AfterViewInit {
  reverseButtons: boolean = false;
  modalTitleText: string;
  modalAcceptText: string;
  modalDeclineText: string;
  modalBodyTextKey: string;
  modalBodyTextParams: any = {};
  modalBodyTextContent: string;
  removeCloseButton: boolean = false;
  robotClassClose: string = 'robot_commonModal_closeIcon';
  robotClassModalTitle: string = 'robot_commonModal_title';
  robotClassModalBody: string = 'robot_commonModal_body';
  robotClassAcceptButton: string = 'robot_commonModal_acceptButton';
  robotClassDeclineButton: string = 'robot_commonModal_declineButton';
  modalBody: TemplateRef<any>;
  onClose = new Subject<boolean>();

  @ViewChild('body', { read: ViewContainerRef }) body: ViewContainerRef;

  constructor(public bsModalRef: BsModalRef) {}

  ngAfterViewInit(): void {
    if (this.modalBody) {
      this.body.createEmbeddedView(this.modalBody);
    }
  }

  accept(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  close(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
